import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { MatSelectionList } from "@angular/material/list"
import { TrColumnInfo, TrCustomizableColumnData } from "./tr-customizable-columns.model"

@Component({
  selector: "tr-customizable-columns",
  styleUrls: ["tr-customizable-columns.component.scss"],
  templateUrl: "tr-customizable-columns.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class TrCustomizableColumnsComponent implements OnInit {
  @ViewChild(MatSelectionList, {static: true}) public list: MatSelectionList

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TrCustomizableColumnData,
    public dialogRef: MatDialogRef<TrCustomizableColumnsComponent>,
  ) {}

  public selected: { [columnId: string]: boolean } = {}

  public ngOnInit(): void {
    this.data.currentColumns.forEach(c => this.selected[c] = true)
  }

  public getSelectedColumns(): string[] {
    const selectedColumns = Object
      .keys(this.selected)
      .filter(s => !!this.selected[s])

    selectedColumns.sort((a, b) => {
      const aIndex = this.data.columns.map(c => c.id).indexOf(a)
      const bIndex = this.data.columns.map(c => c.id).indexOf(b)
      if (aIndex < bIndex) {
        return -1
      }

      return aIndex > bIndex ? 1 : 0
    })

    return selectedColumns
  }

  public onClose(): void {
    this.dialogRef.close(this.getSelectedColumns())
  }

  public get isAllSelected(): boolean {
    return this.getSelectedColumns().length === this.data.columns.length
  }

  public get isAllNotSelected(): boolean {
    return this.getSelectedColumns().length === 0
  }

  public toggle(event: MouseEvent, column: TrColumnInfo): void {
    event.stopImmediatePropagation()
    this.selected[column.id] = !this.selected[column.id]
  }

  public toggleAll(): void {
    if (this.isAllSelected) {
      this.selected = {}
    } else {
      this.selected = {}
      this.data.columns.forEach(c => this.selected[c.id] = true)
    }
  }
}
